
export const CONTEXT = {
  PRODUCTION: 'PRODUCTION',
  SANDBOX: 'SANDBOX'
}

export function getFunctionsOnContext(){
  const FUNCTIONS = {
    [CONTEXT.PRODUCTION]: {
      CONTEXT: CONTEXT.PRODUCTION,
      GET_BOT_INFO: 'callable-CHAT_getBotInfo',
      CHECK_CONVERSATION_STATUS: 'callable-CHAT_checkConversationStatus',
      SEND_MESSAGE: 'callable-CHAT_sendMessage',
      START_CHAT: 'callable-CHAT_startChat',
    }, 
  
    [CONTEXT.SANDBOX]: {
      CONTEXT: CONTEXT.SANDBOX,
      GET_BOT_INFO: 'callable-DRAFT_CHAT_getBotInfo',
      CHECK_CONVERSATION_STATUS: 'callable-DRAFT_CHAT_checkConversationStatus',
      SEND_MESSAGE: 'callable-DRAFT_CHAT_sendMessage',
      START_CHAT: 'callable-DRAFT_CHAT_startChat', 
    }
  }
  const context = CONTEXT[localStorage.getItem('context')] ?? CONTEXT.PRODUCTION;
  return FUNCTIONS[context];
}

export const  DEFAULT_BOT_AVATAR_URL = {
  URL:  "https://firebasestorage.googleapis.com/v0/b/neoronbeta.appspot.com/o/avatar%20(1).png?alt=media&token=be93cdf2-d2de-4db2-8d76-f8e5347e7d88"
}
